import styled from 'styled-components'
import { getRem } from 'styles/utils'

export const NavigationControlStyled = styled.div`
  position: absolute;
  bottom: ${getRem(24)};
  right: ${getRem(24)};
  opacity: 0.5;
`
